import { create } from "zustand";

export type AppTheme = "light" | "dark" | "system";

type AppState = {
  offline: boolean;
  theme: AppTheme;
  setOffline: (offline: boolean) => void;
  setTheme: (theme: AppTheme) => void;
};

const themeStorageKey = "clearscope.theme";

function applyTheme(theme: AppTheme) {
  if (typeof document === "undefined") {
    return;
  }
  document.documentElement.classList.toggle("theme-light", theme === "light");
  document.documentElement.classList.toggle("theme-dark", theme === "dark");
}

function getInitialTheme(): AppTheme {
  if (typeof localStorage === "undefined") {
    return "system";
  }
  const stored = localStorage.getItem(themeStorageKey);
  return stored === "light" || stored === "dark" || stored === "system" ? stored : "system";
}

const initialTheme = getInitialTheme();
applyTheme(initialTheme);

export const useAppStore = create<AppState>((set) => ({
  offline: !navigator.onLine,
  theme: initialTheme,
  setOffline: (offline) => set({ offline }),
  setTheme: (theme) => {
    localStorage.setItem(themeStorageKey, theme);
    applyTheme(theme);
    set({ theme });
  },
}));
